import { Outlet, useLocation } from 'react-router-dom';
import { Box, Flex, useColorModeValue, Container } from '@chakra-ui/react';

export default function AuthLayout() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const location = useLocation();
  
  // Use wider container for signin page (will have 2 columns)
  const isSignIn = location.pathname.includes('signin');
  const maxW = isSignIn ? '6xl' : 'md';

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg={bgColor}
    >
      <Container maxW={maxW} w="full" px={6}>
        <Outlet />
      </Container>
    </Flex>
  );
}
